module.exports = __webpack_public_path__ + "static/ArcherRx-Integrated-Healthcare-Services-min-952d59196822ec71ebdcd36bb4cf70cb.png";